// React
import { useState } from "react"

// Types
import type { UploadType } from "../../types"

export function useUploadData(): {
  assignData: (data: UploadType) => void
  data: UploadType
  reset: () => void
} {
  // Vars
  const defaultData: UploadType = {
    data: [],
    identity_batch: ""
  }

  // Hooks
  const [data, setData] = useState<UploadType>(defaultData)

  // Functions
  const assignData = (data: UploadType): void => {
    setData(data)
  }
  const reset = (): void => {
    setData(defaultData)
  }

  return { data, assignData, reset }
}